import React,{ useEffect,useState,Fragment } from 'react';
import { Table, Modal, message, Button, Col, Input, Popconfirm, Tag } from "antd";
import { PlusOutlined, SettingTwoTone, ExclamationCircleOutlined, EditOutlined, DeleteOutlined, CopyOutlined, FormOutlined, DesktopOutlined, MobileOutlined } from '@ant-design/icons';
import _ from "lodash";
import { useNavigate } from 'react-router';
import useWscCustomFormModal from "@/component/UseWscCustomForm";
import useWscTableList from '@/component/UseWscTableList';
import useWscCustomColumns from '@/component/UseWscCustomColumns';
import ColumnSettings from "@/component/ColumnSettings";
import {request} from '@/utils/useRequest';
import CategoryTree from './category';

const { Search } = Input;

const initParams = {
  pagination: {
    current: 1,
    pageSize: 10
  },
  filters: {
  },
  sorter: null
};


const FormList = ( props ) => {

  const navigate = useNavigate();
  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  const { list, isLoading, pagination, setPage, setFilter, filters, setSorter, Refresh } = useWscTableList({
    //appid:"crttcserver",
    url: "/api/v2/private/dynamicform/list", initParams: initParams
  });
  const { Refresh: refreshColumns, colsettings } = useWscCustomColumns({ key: "formlist" });
  const [columns, setColumns] = useState([]);

  useEffect(() => {
      if (colsettings) {

        let cols = colsettings?.filter(item => item.visible).concat(ExtendColumns);

        // 处理应用类别列，添加图标显示
        let appTypeCol = cols.find(item => item.dataIndex == "AppType" || item.title == "应用类别");
        if (appTypeCol) {
          appTypeCol.render = (appType) => {
            if (appType === "PC" || appType === "pc") {
              return (
                <Tag icon={<DesktopOutlined />} color="blue">
                  PC
                </Tag>
              );
            } else if (appType === "Mini" || appType === "MINI" || appType === "小程序") {
              return (
                <Tag icon={<MobileOutlined />} color="green">
                  小程序
                </Tag>
              );
            }
            return appType;
          };
        }
        
        setColumns(cols);
      }
  }, [colsettings]);

  const ExtendColumns = [
    {
      title: <div>操作 <ColumnSettings topic="formlist" colsettings={colsettings} list={list} onFinish={refreshColumns} /></div>,
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => {
        // console.log('Id, item, idx', Id, idx, item)
        return (
          <Fragment>
            <Button
              type="link" 
              icon={<FormOutlined />}
              title="配置表单"
              onClick={() => {
                if (record.Version == 2) {
                    navigate("/build/v2/" + record.Id);
                } else {
                    navigate("/build/" + record.Id);
                }
                //showDynamicModal(8,data);
              }}
            />
            <Button
              type="link" 
              icon={<CopyOutlined />}
              title="复制"
              onClick={() => {
                showDynamicModal(73, record);
              }}
            />
            <Button 
              type="link" 
              icon={<EditOutlined />}
              title="修改"
              onClick={() => {
                showDynamicModal(64, record);
              }} 
            />
            <Button 
              type="link" 
              icon={<DeleteOutlined />}
              title="删除"
              onClick={()=>{
                Modal.confirm({
                  title: '确认删除',
                  icon: <ExclamationCircleOutlined />,
                  content: '您确定删除此表单么？',
                  onOk: async () => {
                    let result = await request("/api/v2/private/dynamicform/delete", "POST", "json", { id: record.Id });
                    if (result.success) {
                      message.success(result.message);
                      Refresh();
                    } else {
                      Modal.error({ content: result.message });
                    }
                  },
                  okText: '确认',
                  cancelText: '取消',
                });

              }}
            />
          </Fragment>
        );
      },
    },
  ];





  const handleTableChange = (pagination, _filters, sorter) => {
    setPage(pagination.current);
    setFilter({ ...filters, ..._filters });
    setSorter(sorter);
  }


    return (
      <div className="wsc-layout-bg p-4 h-[calc(100vh-6.3rem)] overflow-y-auto">
        <div className="wsc-layout-bg-content">
          <div className="product-list-search">
          <div className="product-list-search_l">
              <div className='flex flex-row items-center pb-4'>
              <Button className="product-list-addbtn mr-4" type="primary" icon={<PlusOutlined />} onClick={() => { 
            showDynamicModal(48, {}); }}>
            新增
          </Button>
                <Search className='w-64' placeholder="请输入查询内容" onSearch={val => {
                    setFilter({ ...filters, keywords: val });
                  }} enterButton />
                   
              </div>
            </div>
          </div>
         
          <div className="flex h-full flex-row">
            <div className='w-1/5'>
              <CategoryTree onChange={(val, left, right) => {
                if (val === null) {
                  // 取消选择分类时，移除Category过滤条件
                  const newFilters = { ...filters };
                  delete newFilters.Category;
                  setFilter(newFilters);
                } else {
                  setFilter({ ...filters, Category: { id: val, left, right } });
                }
              }} />
            </div>
            <Table
              className="w-4/5 h-full mr-4"
              rowKey={"Id"}
              loading={isLoading}
              bordered
              dataSource={list}
              columns={columns}
              pagination={pagination}
              onChange={handleTableChange}
              size="small"
            />
          </div>
          <WscCustomFormModal formId={64}
            OnPayload={(form,name, payload) => {
              if(name == "Cancel"){
                hide(64);
                return;
              } 
              if(!payload.apiresult.success){
                Modal.error({content:payload.apiresult.message});
              } else {
                message.success(payload.apiresult.message);
                Refresh();
                hide(64);
              }
                //hide();
            }} />

          <WscCustomFormModal formId={48}
            OnPayload={(form,name, payload) => {
              if(name == "Cancel"){
                hide(48);
                return;
              } 
              if(!payload.apiresult.success){
                Modal.error({content:payload.apiresult.message});
              } else {
                message.success(payload.apiresult.message);
                Refresh();
                hide(48);
              }
                //hide();
            }} />

          <WscCustomFormModal formId={73}
            OnPayload={(form, name, payload) => {
              if (name == "Cancel") {
                hide(73);
                return;
              }
              if (!payload.apiresult.success) {
                Modal.error({ content: payload.apiresult.message });
              } else {
                message.success(payload.apiresult.message);
                Refresh();
                hide(73);
              }
              //hide();
            }} />

        </div>
      </div>
    );
}


export default FormList